// extracted by mini-css-extract-plugin
module.exports = {"referralWrap":"AcceptReferralCode_referralWrap__1GHyB","instructions":"AcceptReferralCode_instructions__29mLg"};